import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { Router } from '@angular/router'
import { CookieService } from 'ngx-cookie-service'

@Component({
    selector: 'app-device',
    templateUrl: './device.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/lui-select.component.css',
        '../common/common.component.css',
    ],
})
export class DeviceComponent implements OnInit {
    en = {}
    showEN = true
    statusYes_1 = (localStorage.getItem('ngStorage_publicationMode') === 'true' ? 0 : -1)
    statusNo_1 = (localStorage.getItem('ngStorage_publicationMode') === 'false' ? 0 : -1)
    statusYes_2 = (localStorage.getItem('ngStorage_downloadOriginal') === 'true' ? 0 : -1)
    statusNo_2 = (localStorage.getItem('ngStorage_downloadOriginal') === 'false' ? 0 : -1)
    statusYes_3 = (localStorage.getItem('ngStorage_acceptQuickTime') === 'true' ? 0 : -1)
    statusNo_3 = (localStorage.getItem('ngStorage_acceptQuickTime') === 'false' ? 0 : -1)
    // statusYes_4 = (localStorage.getItem('ngStorage_allowExperimentalFeatures') === 'true' ? 0 : -1)
    // statusNo_4 = (localStorage.getItem('ngStorage_allowExperimentalFeatures') === 'false' ? 0 : -1)
    statusYes_4 = -1
    statusNo_4 = -1
    accountId = 0


    constructor(private authData: AuthService, private restApi: RestServices,
                private router: Router, private cookieService: CookieService) {
        this.getCommon()
    }

    getCommon() {
        // set class display theme
        if(localStorage.getItem('classThemeBody')) {
            jQuery('body').attr('class', localStorage.getItem('classThemeBody'))
        }
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                setting: {
                    map: {
                        common: true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                const themeStatus = success['response']['setting']['map']['common']['chooseTheme'] || 'blue'
                if (themeStatus != localStorage.getItem('classThemeBody')) {
                    jQuery('body').attr('class', themeStatus)
                    localStorage.setItem('classThemeBody', themeStatus)
                }
                const checkAddressCommon = success['response']['setting']['map']['common']['address'] || ' '
                const timezone = success['response']['setting']['map']['common']['timezone']
                const countryCode = success['response']['setting']['map']['common']['countryCode']
                if ((!checkAddressCommon || checkAddressCommon === ' ') && (timezone === 'Asia/Tokyo' || timezone === 'Japan' || countryCode === 'JP')) {
                    return this.router.navigateByUrl('/app/main/setting/common')
                }
            })
        })
    }

    ngOnInit() {
        const user = this.authData.getUser();
        if(user['allowExperimental']){
            switch (user['allowExperimental']) {
                case 'true':
                    this.statusYes_4 = 0;
                    break;
                case 'false':
                    this.statusNo_4 = 0;
                    break;
                default:
                    break;
            }
        }
        if(user['_id']){
            this.accountId = user['_id'];
        }
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    toggleYes(id, value) {
        if (value === 'Yes_1') {
            this.statusYes_1 = (id === -1 ? 0 : -1);
            (id === -1 ? localStorage.setItem('ngStorage_publicationMode', 'true') : localStorage.setItem('ngStorage_publicationMode', null))
            this.statusNo_1 = -1
        } else if (value === 'Yes_2') {
            this.statusYes_2 = (id === -1 ? 0 : -1)
            this.statusNo_2 = -1;
            (id === -1 ? localStorage.setItem('ngStorage_downloadOriginal', 'true') : localStorage.setItem('ngStorage_downloadOriginal', null))
        } else if (value === 'Yes_3') {
            this.statusYes_3 = (id === -1 ? 0 : -1)
            this.statusNo_3 = -1;
            (id === -1 ? localStorage.setItem('ngStorage_acceptQuickTime', 'true') : localStorage.setItem('ngStorage_acceptQuickTime', null))
        } else if (value === 'Yes_4') {
            this.statusYes_4 = (id === -1 ? 0 : -1)
            this.statusNo_4 = -1;
            // (id === -1 ? localStorage.setItem('ngStorage_allowExperimentalFeatures', 'true') : localStorage.setItem('ngStorage_allowExperimentalFeatures', null))
            (id === -1 ? this.updateAllowExperimental('true') : this.updateAllowExperimental(null))
        }
    }

    toggleNo(id, value) {
        if (value === 'No_1') {
            this.statusNo_1 = (id === -1 ? 0 : -1);
            (id === -1 ? localStorage.setItem('ngStorage_publicationMode', 'false') : localStorage.setItem('ngStorage_publicationMode', null))
            this.statusYes_1 = -1
        } else if (value === 'No_2') {
            this.statusNo_2 = (id === -1 ? 0 : -1)
            this.statusYes_2 = -1;
            (id === -1 ? localStorage.setItem('ngStorage_downloadOriginal', 'false') : localStorage.setItem('ngStorage_downloadOriginal', null))
        } else if (value === 'No_3') {
            this.statusNo_3 = (id === -1 ? 0 : -1)
            this.statusYes_3 = -1;
            (id === -1 ? localStorage.setItem('ngStorage_acceptQuickTime', 'false') : localStorage.setItem('ngStorage_acceptQuickTime', null))
        } else if (value === 'No_4') {
            this.statusNo_4 = (id === -1 ? 0 : -1)
            this.statusYes_4 = -1;
            // (id === -1 ? localStorage.setItem('ngStorage_allowExperimentalFeatures', 'false') : localStorage.setItem('ngStorage_allowExperimentalFeatures', null))
            (id === -1 ? this.updateAllowExperimental('false') : this.updateAllowExperimental(null))
        }
    }

    loadPageDevice() {
        if (this.authData.getItem('user')) {
            const user = JSON.parse(this.authData.getItem('user'));
            const expires = parseInt((user.expiresInSeconds)) * 1000;
            const timeOut = parseInt(this.authData.getItem('timeout')) + expires;
            const timeNow = Date.now();
            if(timeOut <= timeNow){
                localStorage.removeItem('user')
                localStorage.removeItem('token')
                localStorage.removeItem('timeout')
                this.cookieService.delete('token')
                jQuery('body').attr('class', 'blue')
                localStorage.removeItem('urlLogo')
                localStorage.removeItem('classThemeBody')
                return this.router.navigateByUrl('/app/login')
            }
        }
        return window.location.reload()
    }

    updateAllowExperimental(status){
        const accountUrl = 'account/update-allow-experimental';
        const accountData = {
            status: status,
            accountId: this.accountId
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(accountUrl, accountData, tokenReNew).subscribe(success => {
                const user = this.authData.getUser();
                user['allowExperimental'] = status;
                this.authData.setUser(user);
            })
        })
    }


}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/setting/device/device.component.ts